import { useSuspenseQuery } from '@tanstack/react-query';

import Alert from '@/components/@base/alert';
import Container from '@/components/@base/container';
import Section from '@/components/app/product/components/@shared/section';
import CommentCard from '@/components/app/product/components/bundle-comments/bundle-comment-card';
import Props from '@/components/app/product/components/bundle-comments/type';
import { isBundle } from '@/components/app/product/helpers';
import { getSingleProductOptions } from '@/components/app/product/services/hooks';

import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;
export default function BundleComments({ slug }: Props) {
  const { data } = useSuspenseQuery(getSingleProductOptions(slug));

  return (
    <Container>
      <Alert
        message={productLocalization.bundleCommentsMessage}
        type='info'
        className='my-4 p-2 shadow-[0px_10px_25px_0px_#969BA41A] md:p-4'
      />
      {isBundle(data) && data.bundleItems && (
        <Section className='flex flex-col gap-4'>
          {data.bundleItems.map((item, index) => (
            <CommentCard slug={item.slug} title={item.title} icon={item.icon} key={index} />
          ))}
        </Section>
      )}
    </Container>
  );
}
